module.exports = __webpack_public_path__ + "img/img_engineering_phone_banner.cbcdbb90.png";